export default __webpack_public_path__ + "static/1019-982a368aeb571d3cd6740d1969afdf59.gif";